import {format, isValid, parse} from 'date-fns';

export function parseDateRangeInput(value: string): [Date | null, Date | null] | null {
  if (!value.trim()) return [null, null];
  const parts = value.trim().match(/^(\d{4}\/\d{2}\/\d{2} \d{2}:\d{2})\s*-\s*(\d{4}\/\d{2}\/\d{2} \d{2}:\d{2})$/);
  if (!parts) return null;
  const pattern = 'yyyy/MM/dd HH:mm';
  const start = parse(parts[1], pattern, new Date());
  const end = parse(parts[2], pattern, new Date());
  if (!isValid(start) || !isValid(end) || format(start, pattern) !== parts[1] || format(end, pattern) !== parts[2] || start >= end) return null;
  return [start, end];
}
